"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CorrelationVector = void 0;
// Implements https://aka.ms/CorrelationVector
var CorrelationVector = /** @class */ (function () {
    function CorrelationVector(id) {
        this.childCount = 0;
        this.id = id || generateBase64PseudoUuid();
    }
    CorrelationVector.fromString = function (id, childCount) {
        if (!id) {
            throw new Error('Received invalid correlation vector string');
        }
        var cv;
        if (id.indexOf('.0', id.length - 2) === -1) {
            cv = new CorrelationVector(id);
        }
        else {
            cv = new CorrelationVector(id.substring(0, id.length - 2));
        }
        if (childCount) {
            cv.childCount = childCount;
        }
        return cv;
    };
    CorrelationVector.prototype.newChild = function () {
        ++this.childCount;
        return new CorrelationVector(this.id + '.' + this.childCount.toString());
    };
    CorrelationVector.prototype.toString = function () {
        if (this.id.length > 127) {
            return this.id.substr(0, 127) + '!';
        }
        return this.id;
    };
    return CorrelationVector;
}());
exports.CorrelationVector = CorrelationVector;
var characters = [
    'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I',
    'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R',
    'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a',
    'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j',
    'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's',
    't', 'u', 'v', 'w', 'x', 'y', 'z', '0', '1',
    '2', '3', '4', '5', '6', '7', '8', '9', '+',
    '/'
];
var hashLength = 22;
var result = new Array(hashLength);
function generateBase64PseudoUuid() {
    for (var i = 0; i < hashLength; i++) {
        result[i] = characters[Math.floor(Math.random() * characters.length)];
    }
    return result.join('');
}
//# sourceMappingURL=correlation-vector.js.map